<template>
  <div class="pickup-point" :class="itemClass">
    <input type="radio"
           name="pickupPoint"
           :id="'point-'+ point.id"
           class="pickup-point__input"
           :value="point"
           v-model="deliveryCompanyPoint"
    >
    <label :for="'point-' + point.id" class="pickup-point__label">
      <span class="pickup-point__top">
        <span class="pickup-point__address-wrap">
          <span class="pickup-point__geo-icon">
            <GeoPointIcon/>
          </span>

          <span class="pickup-point__address texts texts_main-15">
            {{ point.address }}
          </span>
        </span>

        <span class="pickup-point__circle">
        </span>
      </span>

      <span class="pickup-point__bottom">
        <span class="pickup-point__schedule-wrap" v-if="point.schedule">
          <span class="pickup-point__schedule-item texts_grey"
                v-if="point.schedule.length > 1"
                v-for="item in point.schedule">
            {{ item.weekDays }}: {{ item.workTime }}
          </span>
           <span class="pickup-point__schedule-item texts_grey"
                 v-else>
            {{ point.schedule.weekDays }}: {{ point.schedule.workTime }}
          </span>
        </span>

        <span class="pickup-point__checked">
          <span class="pickup-point__checked-icon">
            <CheckedPickup/>
          </span>

          <span class="pickup-point__checked-text">
            Выбран
          </span>
        </span>
      </span>
    </label>
  </div>
</template>

<script>
import GeoPointIcon from "../icons/GeoPointIcon.vue";
import CheckedPickup from "../icons/CheckedPickup.vue";
import cartService from "../../services/cart.service";
import {mapState} from "vuex";

export default {
  name: "ThePickupPoint",
  components: {
    GeoPointIcon,
    CheckedPickup
  },
  watch: {

  },
  computed: {
    deliveryCompanyPoint: {
      get () {
        return this.$store.state.order.deliveryCompanyPoint;
      },
      set (value) {
        this.$store.commit('order/setDeliveryCompanyPoint', value);
        this.$store.commit('order/setParcelShop', value.id);
        document.dispatchEvent(new CustomEvent('pickupPoint:point:changed', {detail: {value: value.id}}))
        this.fetchDeliveryCost(value);
      }
    },
  },

  methods: {
    async fetchDeliveryCost(val) {
      try {
        this.setLoading(true);
        this.setLoadingText('Рассчитываем доставку...')
        const response = await cartService.fetchDeliveryCostByTk(val);
        const data = response.data;
        this.$store.commit('cart/setDeliveryPrice', data.price);
        this.$store.commit('order/setDeliveryPrice', data.price);
        this.setLoading(false);
      } catch (error) {
        console.error("Error fetching delivery cost:", error);
      }
    },
    setLoading(value) {
      this.$store.commit('cart/setLoading', value);
    },
    setLoadingText(value) {
      this.$store.commit('cart/setLoadingText', value);
    }
  },
  props: {
    itemClass: String,
    point: Object
  },
}
</script>